export default {
  "1000": "خطایی از سمت سرور رخ داد",
  "1050": "فرمت فایل ارسالی شما، قابل شناسایی نیست.",
  "1051": "حجم فایل ارسالی بیشتر از مقدار تعیین شده است.",
  "1052": "متاسفانه سرور‌های شافل دچار یک مشکل فنی شده‌ اند.",
  "1053": "فرمت فایل ارسالی شما، قابل شناسایی نیست.",
  "1054": "ابعاد فایل ارسالی متناسب با مقدار تعیین شده نیست.",
  "1055": "فایل مورد نظر شما پیدا نشد.",
  "1100": "این قسمت حتما باید تکمیل شود.",
  "2000": "اطلاعات وارد شده صحیح نیست.",
  "3553": "این ایمیل قبلاً ثبت نام شده‌است",
  "4001": "متاسفانه اجازه دسترسی به این بخش برای شما وجود ندارد.",
  "4002": "کلید اکانت شما منقضی شده. در صورت نیاز دوباره وارد شوید",
  "4003": "حساب کاربری شما غیر فعال شده. لطفا با پشتیبانی تماس بگیرید.",
  "4004": "متن امنیتی را صحیح وارد نکردید.",
  "404": "چیزی پیدا نشد",
  "6900": "کد هدیه نامعتبر است!",
  "6901": "این کد هدیه قبلاً استفاده شده‌است",
  "6903": "درخواست‌های هدیهٔ شما بیش از حد مجاز در روز بوده‌است!",
  "6905": "شما هدیهٔ دیگری در این روز دریافت نخواهید کرد!",
  "6906": "پنج نفر رو دعوت کن تا بازم بتونی با گوش‌دادن هدیه بگیری :)",
  "6953": "تعداد درخواست ارسال پیامک شما بیش از حد مجاز است!",
  "6954": "شما هنوز شماره موبایل خود را تأیید نکرده‌اید",
  "6955": "این شماره موبایل در شافل ثبت نام کرده‌است.",
  'network': 'خطا در اتصال',
  'default': 'خطایی رخ داد',
  'required': 'این قسمت اجباری است',  
  'bad-credentials': 'اطلاعات ورود اشتباه است',
}